import React, { useState, useEffect } from "react";
import GridTable from "@nadavshaar/react-grid-table";
import setColumns from "./setColumns.js";
import Modalv2 from "../../../components/tables/Modalv2";
import ValidView from "../../../components/app/validView";
import { Button, Spinner } from 'react-bootstrap';
import { FaAddressBook } from "react-icons/fa";
import ModalMultiSelect from './ModalMultiSelect.js';
import ModalExportExcel from "../../../components/tables/ModalExportExcel";
import CustomHeader from "../../../components/tables/CustomHeader";
import { searchUtils } from "../../../components/tables/searchUtils";

const PayMethods = () => {
  const rowsPerPageString = process.env.REACT_APP_GRID_ROWSPERPAGE;
  const rowsPerPageArray = rowsPerPageString.split(',').map(Number);

  const nameView = "PayMethod";
  const { allowWrite, allowView, userToken } = ValidView('PayMethods');
  const [dataItem, setItem] = useState({ codeItem: 0, typeView: '', nameView: '' });

  const [page, setPage] = useState(1);
  const [objFilter, setObjFilter] = useState([]);
  const [stringFilter, setStringFilter] = useState(null);

  const [pageSize, setPageSize] = useState(rowsPerPageArray[0]);
  const [isLoading, setLoading] = useState(true);
  const [columnsGrid, setColumnsGrid] = useState([]);
  const [rowsLoading, setRowsLoading] = useState(false);

  const [show, setShow] = useState(false);
  const [show_sc, setshow_sc] = useState(false);
  const handleClose = () => setShow(false);
  const handleClose_sc = () => setshow_sc(false);
  const [show_excel, setshow_excel] = useState(false);
  const handleClose_excel = () => setshow_excel(false);
  const [selectedRowsIds, setSelectedRowsIds] = useState([]);

  const modalDetail = (codeItem, typeView) => {
    setShow(true);
    setItem({ codeItem, typeView, nameView });
  };

  const modal_sc = (codeItem, typeView) => {
    setshow_sc(true);
    //setItem({ codeItem, typeView, nameView });
  };

  const modal_excel = () => {
    setshow_excel(true);
  };

  const modal_nt = (codeItem, typeView) => {
    setshow_nt(true);
    //setItem({ codeItem, typeView, nameView });
  };

  useEffect(() => {
    if (allowView) {
      setColumnsGrid(setColumns({ modalDetail, allowWrite, changeDelay }));
      setRowsLoading(true);
    }
  }, [allowView, allowWrite]);

  const changeDelay = (textSearch, tableManager, column) => {
    const { searchApi } = tableManager;
    const { searchText, setSearchText } = searchApi;
    const setSearchAndFilter = (searchText, stringFilter) => {
      setSearchText(searchText);
      setStringFilter(stringFilter);
    };
    searchUtils(textSearch, setSearchAndFilter, column, searchText, objFilter);
  };

  const onRowsRequest = async (requestData, tableManager) => {
    setLoading(true);
    
    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userToken
      }
    };

    const response = await fetch(process.env.REACT_APP_NERTHUS_API_URL + '/catalogs/paymethods?page=' + (page) + '&perPage=' + pageSize + requestData.searchText, requestOptions)
    .then((response) => {
      setLoading(false);
      return response.json();
    }).catch(console.warn);
    
  if (!response?.data) return;

    return {
      rows: response.data,
      totalRows: response.total_count,
    };
  };

  const OnPageChange = (event) => {
    setPage(event);
  }

  let dataMultiSelect = { 'typeView': 'View', 'codeItem': selectedRowsIds, 'nameView': 'Send Pay Methods' };
  const urlBaseExport = '/catalogs/paymethods/exportToExcel?page=1&perPage=9999';

  let addButton = "";
  if (allowWrite) {
    addButton = <Button type="button" className="btn btn-success" size="sm" alt="Create" onClick={() => { modalDetail(0, "Create"); }}> <FaAddressBook /> Create {nameView} </Button>;
  }

  return (<>
    <div className="tableWrapper">
      {!rowsLoading
        ? (<Spinner animation="border" role="status" variant="secondary" >
          <span className="visually-hidden">Loading...</span>
        </Spinner>) : (<>
          <GridTable
            columns={columnsGrid}
            rowIdField={'code'}
            onRowsRequest={onRowsRequest}
            isLoading={isLoading}
            pageSizes={rowsPerPageArray}
            pageSize={pageSize}
            onPageSizeChange={setPageSize}
            onPageChange={OnPageChange}
            selectedRowsIds={selectedRowsIds}
            onSelectedRowsChange={setSelectedRowsIds}
            showSearch={false}
            showColumnVisibilityManager={false}
            highlightSearch={false}
            minSearchChars={3}
            components={{ Header: (props) => <CustomHeader {...props} selectedRowsIds={selectedRowsIds} allowWrite={allowWrite} modal_excel={modal_excel} modal_sc={modal_sc} setStringFilter={setStringFilter} addButton={addButton} /> }}
          />
        </>)}
    </div>
    <Modalv2 show={show} handleClose={handleClose} dataItem={dataItem} setRenderRows={[]} />
    <ModalMultiSelect show={show_sc} handleClose={handleClose_sc} dataItem={dataMultiSelect} setRenderRows={[]} />
    <ModalExportExcel show={show_excel} handleClose={handleClose_excel} objTextFind={stringFilter} urlBaseExport={urlBaseExport} nameFile={'PayMethods.xlsx'} />
  </>)
};

export default PayMethods;